import {
  FETCH_PAGINATED_PRODUCT_GROUPS,
  FETCH_ALL_PRODUCT_GROUPS,
  RESET_PRODUCT_GROUPS,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_PRODUCT_GROUPS](state, { productGroups, pagination }) {
    state.items = productGroups;
    state.pagination = pagination;
  },

  [FETCH_ALL_PRODUCT_GROUPS](state, productGroups) {
    state.all = productGroups;
  },

  [RESET_PRODUCT_GROUPS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productGroup/mutations.js